import config from '@/config/index'
const modulesFiles = import.meta.globEager('./modules/*.js')

const overrideMap = config.overrideMap || {}
const modules = Object.keys(modulesFiles).reduce((modules, modulePath) => {
  const value = modulesFiles[modulePath]
  value.default.forEach(m => {
    if (overrideMap[m.name]) {
      m.url = overrideMap[m.name]
    }
    modules.push(m)
  })
  return modules
}, [])

export default modules
